/**
 * First executable API statement from Validation / Monaco detected_lines lists.
 * Never invents line 0 — empty metadata means unknown (caller should use Stepping).
 *
 * @param {...unknown} lists Candidate detected_lines arrays (first non-empty wins).
 * @returns {{ line: number, column: number } | null}
 */
export function firstApiStatementFromDetected(...lists) {
    for (const detected of lists) {
        if (!Array.isArray(detected) || detected.length === 0)
            continue;
        const row = detected[0];
        const line = row?.Line;
        if (line == null || line < 0)
            continue;
        return { line, column: row.Column ?? 0 };
    }
    return null;
}

/**
 * Step Over/Into from stopped: Stepping:false only when a known first-pause BP exists.
 * @param {{ stepping: boolean, canPauseAtStart: boolean }} opts
 * @returns {boolean} Effective Stepping flag for StartDebugging.
 */
export function effectiveSteppingFromStopped({ stepping, canPauseAtStart }) {
    if (!stepping)
        return false;
    return !canPauseAtStart;
}
